import classNames from 'classnames';
import { Flame } from 'lucide-react';
import i18n from '@/settings/i18n';

const t = i18n.init('homepage');

const FlashSaleBadge = ({ className }: { className?: string }) => (
  <div
    className={classNames(
      'h-5 w-fit bg-[#fee9e8] px-2 text-xxs font-bold leading-none text-[#e10b44]',
      className,
    )}
  >
    <div className="flex h-full w-full items-center gap-x-1">
      <Flame className="h-3 w-3 shrink-0 fill-[#e10b44]" strokeWidth={2.5} />
      {t`Flash Sale`}
    </div>
  </div>
);

export default FlashSaleBadge;
